module.exports = __webpack_public_path__ + "static/media/consulteer-logo-2020-white-transparent-800w.f6a53db2.png";